@if (displayCharts) {
  <div class="flex items-center justify-around">
    <div class="mt-[20px] flex items-center justify-between w-full pl-[20px] pr-[10px]">
      <div class="text-[24px] leading-[32px] font-bold text-black"
        >Statistics detail</div>
      <ion-buttons slot="end">
        <ion-button (click)="close()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
}

<div class="w-full py-[12px] px-[20px] flex flex-col gap-[20px] overflow-y-auto"
[ngClass]="!displayCharts ? 'flex items-center justify-center' : 'min-h-[70vh] mt-[10px]'">

  <!--Stats container-->
  @if (!displayCharts) {
    <div
      class="flex flex-col gap-[10px]"
      [ngClass]="displayCharts ? 'gap-[15px]' : 'items-start justify-center'"
    >
      <div
        *ngFor="let stat of stats"
        class="flex flex-row w-full items-center gap-[3px]"
      >
        <div class="w-[20px] flex justify-center items-center flex-shrink-0">
          <ark-lib-icon-name [name]="stat.icon"></ark-lib-icon-name>
        </div>
        <div
          class="text-black text-xs font-normal leading-tight w-[40px] text-left"
        >
          {{ stat.value | number: '1.0-2'  }} 
        </div>
        <div
          class="font-normal text-[12px] leading-[16px] flex-1 text-left pl-[8px]"
        >
          {{ stat.label }}
        </div>
      </div>
    </div>
  }

  @if (displayCharts) {

    <!-- Follower Chart Card -->
    <div
    class="h-[250px] rounded border border-solid border-[1px] border-[#D2D5DA] py-[10px]"
    >
      <div class="flex items-center justify-between px-[10px]">
        <div class="text-[16px] font-semibold"># of Followers:</div>
        <div class="text-[16px] font-semibold">{{ filteredFollowerTotal }}</div>
      </div>

      <div
        echarts
        [options]="followerChartOptions"
        class="w-full h-[165px]"
      ></div>

      <!-- Filter Buttons -->
      <div class="flex justify-around mt-2 bg-[#F3F4F6] p-[4px] mx-[10px] rounded-[6px]">
        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeFollowerRange === '1D'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setFollowerRange('1D')"
        >
          1 Day
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeFollowerRange === '1W'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setFollowerRange('1W')"
        >
          1 Week
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeFollowerRange === '1M'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setFollowerRange('1M')"
        >
          1 Month
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeFollowerRange === 'MAX'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setFollowerRange('MAX')"
        >
          Max
        </button>
      </div>
    </div>

    <!-- Backing Chart Card -->
    <div
    class="h-[250px] rounded border border-solid border-[1px] border-[#D2D5DA] py-[10px]"
    >
      <div class="flex items-center justify-between px-[10px]">
        <div class="text-[16px] font-semibold"># of Backers:</div>
        <div class="text-[16px] font-semibold">{{ filteredBackingTotal }}</div>
      </div>

      <div echarts [options]="backingChartOptions" class="w-full h-[165px]"></div>

        <!-- Filter Buttons -->
      <div class="flex justify-around mt-2 bg-[#F3F4F6] p-[4px] mx-[10px] rounded-[6px]">
        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="activeBackingRange === '1D' ? 'bg-white text-black' : 'text-[#6D7280]'"
          (click)="setBackingRange('1D')"
        >
          1 Day
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="activeBackingRange === '1W' ? 'bg-white text-black' : 'text-[#6D7280]'"
          (click)="setBackingRange('1W')"
        >
          1 Week
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="activeBackingRange === '1M' ? 'bg-white text-black' : 'text-[#6D7280]'"
          (click)="setBackingRange('1M')"
        >
          1 Month
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="activeBackingRange === 'MAX' ? 'bg-white text-black' : 'text-[#6D7280]'"
          (click)="setBackingRange('MAX')"
        >
          Max
        </button>
      </div>
    </div>

    <!-- Ratings Card -->
    <div
      class="h-[330px] rounded border border-solid border-[1px] border-[#D2D5DA] py-[10px]"
    >
      <div class="w-full max-w-[520px] text-slate-900">
        <!-- Header -->
        <div class="flex items-center justify-between px-[5px] mb-2">
          <div class="text-[16px] font-semibold">Average Star Rating:</div>
          <div class="text-[16px] font-semibold">{{ ratingAverage | number:'1.1-2' }}</div>
        </div>

        <!-- Stars (supports half star) -->
        <div class="flex justify-center gap-2 mx-[20px] mb-2">
          <ng-container *ngFor="let star of [1,2,3,4,5]">
            <ark-lib-icon-name
              [name]="getStarIcon(star)"
              class="text-3xl text-slate-800"
            ></ark-lib-icon-name>
          </ng-container>
        </div>

        <!-- Total Ratings -->
        <div class="text-center text-[10px] text-slate-700 mx-[20px] mb-[15px]">
          {{ ratingCount }} ratings
        </div>

        <!-- Breakdown -->
        <div class="space-y-4 mx-[20px]">
          <ng-container *ngFor="let star of stars">
            <div class="flex items-center gap-3">
              <!-- Label -->
              <div class="flex items-center gap-1 w-10 font-semibold text-slate-800">
                <span
                  class="text-[20px] font-semibold"
                  [ngClass]="star == 1 ? 'mr-[3px]' : ''"
                >
                  {{ star }}
                </span>
                <ark-lib-icon-name name="star-outline"></ark-lib-icon-name>
              </div>

              <!-- Bar -->
              <div class="relative flex-1 h-[4px] bg-slate-200 rounded-full overflow-hidden">
                <div
                  class="absolute left-0 top-0 h-full bg-slate-700 rounded-full"
                  [style.width.%]="getRatingPercent(star)"
                ></div>
              </div>

              <!-- Count -->
              <div class="w-8 text-right text-[10px] text-slate-600">
                {{ getRatingCount(star) }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Comment Chart Card -->
    <div
      class="h-[250px] rounded border border-solid border-[1px] border-[#D2D5DA] py-[10px]"
    >
      <div class="flex items-center justify-between px-[10px]">
        <div class="text-[16px] font-semibold"># of Comments:</div>
        <div class="text-[16px] font-semibold">{{ filteredCommentTotal }}</div>
      </div>

      <div
        echarts
        [options]="commentChartOptions"
        class="w-full h-[165px]"
      ></div>

      <!-- Filter Buttons -->
      <div class="flex justify-around mt-2 bg-[#F3F4F6] p-[4px] mx-[10px] rounded-[6px]">
        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeCommentRange === '1D'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setCommentRange('1D')"
        >
          1 Day
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeCommentRange === '1W'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setCommentRange('1W')"
        >
          1 Week
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeCommentRange === '1M'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setCommentRange('1M')"
        >
          1 Month
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeCommentRange === 'MAX'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setCommentRange('MAX')"
        >
          Max
        </button>
      </div>
    </div>

    <!-- Commitment Chart -->
    <!-- <div
    class="h-[200px] rounded border border-solid border-[1px] border-[#D2D5DA] py-[10px] mt-[5px]"
    >
      <div class="flex items-center justify-between px-[10px]">
        <div class="text-[16px] font-semibold">Commitment Level:</div>
        <div class="text-[16px] font-semibold">
          {{ averageCommitmentLevel }}%
        </div>
      </div>
      <div
      echarts
      [options]="commitmentChartOptions"
      class="w-full  h-[180px]"
      ></div>
    </div> -->

    <!-- Unique Views Chart Card -->
    <!-- <div
      class="h-[250px] rounded border border-solid border-[1px] border-[#D2D5DA] py-[10px]"
    >
      <div class="flex items-center justify-between px-[10px]">
        <div class="text-[16px] font-semibold"># of Unique Views:</div>
        <div class="text-[16px] font-semibold">{{ filteredUniqueViewsTotal }}</div>
      </div>

      <div
        echarts
        [options]="uniqueViewsChartOptions"
        class="w-full h-[165px]"
      ></div>

      <div class="flex justify-around mt-2 bg-[#F3F4F6] p-[4px] mx-[10px] rounded-[6px]">
        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeUniqueViewsRange === '1D'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setUniqueViewsRange('1D')"
        >
          1 Day
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeUniqueViewsRange === '1W'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setUniqueViewsRange('1W')"
        >
          1 Week
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeUniqueViewsRange === '1M'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setUniqueViewsRange('1M')"
        >
          1 Month
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeUniqueViewsRange === 'MAX'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setUniqueViewsRange('MAX')"
        >
          Max
        </button>
      </div>
    </div> -->
    
    <!-- Share Chart Card -->
    <div
      class="h-[250px] rounded border border-solid border-[1px] border-[#D2D5DA] py-[10px]"
    >
      <div class="flex items-center justify-between px-[10px]">
        <div class="text-[16px] font-semibold"># of Shares:</div>
        <div class="text-[16px] font-semibold">{{ filteredShareTotal }}</div>
      </div>

      <div
        echarts
        [options]="shareChartOptions"
        class="w-full h-[165px]"
      ></div>

      <!-- Filter Buttons -->
      <div class="flex justify-around mt-2 bg-[#F3F4F6] p-[4px] mx-[10px] rounded-[6px]">
        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeShareRange === '1D'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setShareRange('1D')"
        >
          1 Day
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeShareRange === '1W'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setShareRange('1W')"
        >
          1 Week
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeShareRange === '1M'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setShareRange('1M')"
        >
          1 Month
        </button>

        <button
          class="text-[12px] font-medium leading-[20px] px-2 py-[4px] rounded-md transition-colors duration-150 h-[27px]"
          [ngClass]="
            activeShareRange === 'MAX'
              ? 'bg-white text-black'
              : 'text-[#6D7280]'
          "
          (click)="setShareRange('MAX')"
        >
          Max
        </button>
      </div>
    </div>
  } 
</div>
